const EXCLUDED_FROM_RETURN = [
  "satellite messengers",
  "park passes",
  "handheld gps",
  "wrist gps",
  "cycling computers",
  "gps sports watches",
  "car gps",
  "bike resistance trainers",
  "action cams",
  "lift tickets"
  // memberships aren't PDP items
  // gift cards aren't PDP items
];
const EXCLUDED_FROM_MABC = [
  "park passes",
  "lift tickets"
];
const isReturnExcludedItem = (itemCategory) => EXCLUDED_FROM_RETURN.includes(itemCategory.toLowerCase());
const isMABCExcludedItem = (itemCategory) => EXCLUDED_FROM_MABC.includes(itemCategory.toLowerCase());
export {
  EXCLUDED_FROM_RETURN,
  isMABCExcludedItem,
  isReturnExcludedItem
};
//# sourceMappingURL=isReturnAndMABCExcludedItem.mjs.map
